import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MessageActivitiesNull } from 'src/assets/data/errors-message';
import { Router } from '@angular/router';
import { AccessFormServiceService } from '@core/services/form/access-form-service.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-routine-modal',
  templateUrl: './routine-modal.component.html',
  styleUrls: ['./routine-modal.component.scss'],
})
export class RoutineModalComponent {
  public readonly pageSize = 1; // Ítems por página
  readonly messageClientNull = [MessageActivitiesNull];
  currentMonth: string = '';

  constructor(
    public readonly dialogRef: MatDialogRef<RoutineModalComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
    private readonly router: Router,
    private readonly accessService: AccessFormServiceService,
    private readonly datePipe: DatePipe
  ) { this.setCurrentMonth();}
  onPageChange(page: number) {
    this.data.routine = this.findRoutineByPosition(page + 1);
  }

  close(): void {
    this.dialogRef.close();
  }

  goToUrl(url: string) {
    window.open(url, '_blank', 'noopener');
  }


  goToUrlOpen(value, routine) {
    // Verificar que todos los campos necesarios existan y no estén vacíos
    if (value?.idForm && value.idForm !== '' && value?.id && routine?.id) {
      // Crear el objeto con los tres parámetros para acceso
      const accessParams = {
        idForm: value.idForm,
        idActivity: value.id,
        idRoutine: routine.id,
      };
  
      // Permitir acceso y almacenar los parámetros
      this.accessService.allowAccess(accessParams);
  
      // Crear la URL con todos los parámetros como segmentos de la ruta
      const url = this.router.createUrlTree([
        '/formulario',
        value.idForm,
        value.id,
        routine.id
      ]).toString();
  
      window.open(url, '_blank', 'noopener');
    } else {
      // Si alguno de los parámetros falta, abrir `formatLink` si está disponible
      window.open(value?.formatLink, '_blank', 'noopener');
    }
  }  
  
  findRoutineByPosition(position: number) {
    return this.data.routines.routines.find(
      (routine: any) => routine.position === position
    );
  }

  textLines(text: string): string[] {
    return (text ?? '').split('\n');
  }
  setCurrentMonth(): string {
    const now = new Date();
    this.currentMonth = this.datePipe.transform(now, 'MMMM', undefined, 'es-PE') || 'Mes desconocido';
    
    // Convertir la primera letra a mayúscula
    if (this.currentMonth) {
      this.currentMonth = this.currentMonth.charAt(0).toUpperCase() + this.currentMonth.slice(1);
    }
  
    // Retornar el valor de currentMonth
    return this.currentMonth;
  }
  getLastValidIndex(activities: any[]): number {
    for (let i = activities.length - 1; i >= 0; i--) {
      if (activities[i].formatName && activities[i].formatName.trim() !== '') {
        return i;
      }
    }
    return -1; // Si no hay elementos válidos
  } 
  
}
